import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=a17e4fde&scoped=true&lang=html"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e4fde",
  null
  
)

export default component.exports